export default __webpack_public_path__ + "static/media/promo_05.080c78a3.jpg";